import React from 'react';
import { unescape } from 'lodash/fp';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import Textarea from 'components/shared/debouncedTextArea';

const CaptionFooter = ({ onChange, caption, disabled }) => (
  <div className="EditorElement-footer EditorElement-footer--caption">
    <Text
      variant={TEXT_VARIANTS.BODY}
      placeholder={t('element_builder.caption_placeholder')}
      component={Textarea}
      onChange={onChange}
      value={unescape(caption)}
    />
  </div>
);

export default CaptionFooter;
